import { useEffect, useState } from 'react';
import { useSelector, useStore, shallowEqual } from 'react-redux';
import { getOrderTiming } from '../util/orderTiming';

export default function useOrderTiming() {
  const store = useStore();
  const [, tick] = useState(0);
  useEffect(() => {
    const update = () => tick((value) => value + 1);
    const timer = window.setInterval(update, 30000);
    document.addEventListener('visibilitychange', update);
    return () => {
      window.clearInterval(timer);
      document.removeEventListener('visibilitychange', update);
    };
  }, []);
  const timing = useSelector((state) => getOrderTiming(state), shallowEqual);
  const checkoutId = useSelector((state) => state.order?.checkoutData?.id);
  return {
    ...timing,
    // Re-read immediately before asynchronous payment/checkout work.
    canContinue: () => {
      const current = getOrderTiming(store.getState());
      return !current.requiresConfirmation && current.key === timing.key;
    },
    canPay: () => {
      const current = getOrderTiming(store.getState());
      return (
        !current.requiresConfirmation &&
        current.checkoutMatches &&
        current.key === timing.key &&
        store.getState().order?.checkoutData?.id === checkoutId
      );
    },
  };
}
